import React from 'react';
import { CandidateSortField } from 'modules/candidate-profile/tables/sorting/candidateSort';
import { TableV3ColDefs } from 'common/table/types/TableV3';
import { CandidateProfileTableColumns } from 'modules/candidate-profile/tables/types/CandidateProfileTable';
import {
  CandidateFilterValueType,
  SourcingFilterField
} from 'modules/candidate-profile/types/CandidateSearchFilter';

const SELECTION_TYPES = [
  CandidateFilterValueType.TEXT,
  CandidateFilterValueType.TEXT_ARRAY
];

type WithFilterModeHeadersParams = {
  columns: TableV3ColDefs<CandidateProfileTableColumns, CandidateSortField>;
  availableFilters: SourcingFilterField[];
  renderHeader: (field: string) => React.ReactNode;
};

/**
 * Only columns the contract can express a mode for get the control; offering
 * "exclude" on a column the search cannot exclude by would be a lie.
 */
export const withFilterModeHeaders = ({
  columns,
  availableFilters,
  renderHeader
}: WithFilterModeHeadersParams): TableV3ColDefs<
  CandidateProfileTableColumns,
  CandidateSortField
> => {
  const selectable = new Set(
    availableFilters
      .filter((available) => SELECTION_TYPES.includes(available.type))
      .map((available) => available.field)
  );

  return columns.map((column) => {
    const field = column.field as string | undefined;
    if (!field || !selectable.has(field)) return column;

    if (column.filterOptions) {
      return {
        ...column,
        filterOptions: {
          ...column.filterOptions,
          headerContent: renderHeader(field),
          showCheckboxes: true,
          requiresApply: true
        }
      };
    }

    if (column.serverFilterOptions) {
      return {
        ...column,
        serverFilterOptions: {
          ...column.serverFilterOptions,
          headerContent: renderHeader(field),
          showCheckboxes: true,
          requiresApply: true
        }
      };
    }

    return column;
  }) as TableV3ColDefs<CandidateProfileTableColumns, CandidateSortField>;
};
